<template>
  <section>
    <b-modal width="680px" :active.sync="isCardModalActive" :can-cancel="true">
      <div class="card" style="border-radius: 5px;" v-if="isCardModalActive">
        <header class="card-header">
          <div class="card-header-title edit-title-wrapper">
            <span class="edit-title">スケジュール取り込み</span>
          </div>
        </header>
        <div class="card-content scroll-box">
            <div class="-bottom-8px" style="display: flex;">
              <p class="-right-8px"><b>インポート内容</b></p>
              <b-upload v-model="csvFile" accept=".csv">
                <a class="button is-small">
                  <b-icon icon="upload"></b-icon>
                  <span>インポートするファイルを選択</span>
                </a>
              </b-upload>
            </div>
            <p class="desc">
              CSVはカンマ区切りで下記に合わせた形で入力したデータを用意してください。
              <br>A列：タイトル（必須）
              <br>B列：開始日時（必須）※表示形式：2025-01-01 00:00:00
              <br>C列：終了日時（必須）※表示形式：2025-01-01 23:59:59
              <br>D列：公開設定（必須）※公開：0、非公開：1
              <br>E列：メールアドレス（必須）
              <br>F列：詳細（省略可）
              <!-- <br>G列：参加者（省略可）※複数人いる場合はカンマ区切り -->
            </p>
            <table>
              <tr>
                <th class="table-th">タイトル</th>
                <th class="table-th">開始日時</th>
                <th class="table-th">終了日時</th>
                <th class="table-th">公開設定</th>
                <th class="table-th">メールアドレス</th>
                <th class="table-th">詳細</th>
                <!-- <th class="table-th">参加者</th> -->
              </tr>
              <tr v-for="(d, idx) in importData" :key="idx">
                <td class="table-td">
                  <textarea class="textarea is-small" maxlength="100" v-model="d.title"></textarea>
                </td>
                <td class="table-td">
                  <textarea class="textarea is-small" maxlength="50" v-model="d.start"></textarea>
                </td>
                <td class="table-td">
                  <textarea class="textarea is-small" maxlength="50" v-model="d.end"></textarea>
                </td>
                <td class="table-td">
                  <b-select placeholder="公開設定を選択" v-model="d.private">
                    <option
                    v-for="(s, index) in select"
                    :value="index"
                    :key="index">
                    {{ select[index] }}
                  </option>
                </b-select>
              </td>
              <td class="table-td">
                <textarea class="textarea is-small" maxlength="50" v-model="d.email"></textarea>
              </td>
              <td class="table-td">
                <textarea class="textarea is-small" maxlength="1000" v-model="d.description"></textarea>
              </td>
              <td class="table-td">
                  <div style="display: flex;">
                    <button
                    @click="addRecord(idx)"
                    class="button is-small is-primary -left-8px">追加</button>
                    <button
                    @click="delRecord(idx)"
                    class="button is-small is-danger -left-8px -right-8px">削除</button>
                  </div>
                </td>
              </tr>
            </table>
          </div>
          <!-- フッターアクション -->
          <div class="footer-box">
            <button class="button" @click="cancel">キャンセル</button>
            <button class="button is-primary" :disabled="isDataCheck" @click="importSchedule()">追加する</button>
          </div>
        </div>
    </b-modal>
  </section>
</template>

<script>
import Encoding from 'encoding-japanese'

export default {
  name: 'ModalImportEvent',
  props: {
    company: {
      type: String,
      require: true
    },
  },
  data () {
    return {
      isCardModalActive: false,
      importData: [],
      csvFile: null,
      confirmDesc: '予定の取り込みを開始してもよろしいでしょうか？',
      select: [
        '公開',
        '非公開'
      ],
    }
  },
  watch: {
    csvFile () {
      if (this.csvFile) {
        this.csvFileImport()
      }
    }
  },
  computed: {
    isDataCheck () {
      if (this.importData.length == 0) return true
      let disabled = false
      for (const data of this.importData) {
        if (data.title.length < 1) disabled = true
        if (data.start.length < 1) disabled = true
        if (data.end.length < 1) disabled = true
        if (data.private.length < 1) disabled = true
        if (!data.email.match(/^\w+([-+.]\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*$/)) disabled = true
      }
      return disabled
    }
  },
  methods: {
    cancel () {
      this.importData = []
      this.csvFile = null
      this.isCardModalActive = false
    },
    importSchedule () {
      if (!this.checkRecord()) return
      if (confirm(this.confirmDesc)) {
        this.$store.dispatch('calendar/importSchedule', {data: JSON.parse(JSON.stringify(this.importData)), company: this.company})
        .then(() => {
          this.isCardModalActive = false
        })
      }
      this.importData = []
    },
    // インポートデータ 項目追加
    addRecord (idx) {
      if (this.importData.length > 3000) {
        alert('追加の上限値に達しました。')
        return
      }
      this.importData.splice(idx + 1, 0, {
        title : '',
        start: '',
        end: '',
        private: 0,
        email: '',
        description: '',
      })
    },
    // インポートデータ 項目削除
    delRecord (idx) {
      if (this.importData.length === 1) {
        alert('これ以上削除することはできません。')
        return
      }
      this.importData.splice(idx, 1)
    },
    checkRecord () {
      for (const record of this.importData) {
        if (record.title == '') {
          alert('タイトルは省略できません。')
          return false
        }
        if (record.start == '' || record.end == '') {
            alert('開始日時および終了日時は省略できません。')
            return false
        }
        if (record.start > record.end) {
          alert("開始日時は終了日時より前に設定してください。");
          return;
        }
        for (const key of Object.keys(record)) {
          if (key === 'private') {
            if (record[key] < 0 || record[key] > 1) {
              alert('公開設定を選択してください')
              return false
            }
          } else {
            if (record[key].includes('\n') || record[key].includes('\r')) {
              alert('改行が含まれているためインポートできません。')
              return false
            }
          }
        }
      }
      return true
    },
    // CSV インポート（検索用）
    csvFileImport () {
      let reader = new FileReader()
      reader.onload = (e) => {
        const res = new Uint8Array(e.target.result)
        const encoding = Encoding.detect(res)
        const data = Encoding.convert(res, {
          to: 'unicode',
          from: encoding,
          type: 'string'
        })
        const arr = data.trim().replace(/\"/g, "").replace(/\r/g, "").split("\n").map(v => v.split(","))
        let insertArr = []

        for (let i in arr) {
          let param = {
            title : '',
            start: '',
            end: '',
            private: 0,
            email: '',
            description: '',
          }
          for (let j in arr[i]) {
            switch (Number(j)) {
              case 0:
                param.title = arr[i][j]
                break
              case 1:
                param.start = arr[i][j]
                break
              case 2:
                param.end = arr[i][j]
                break
              case 3:
                param.private = Number(arr[i][j])
                break
              case 4:
                param.email = arr[i][j]
                break
              case 5:
                param.description = arr[i][j]
                break
            }
          }
          insertArr.push(param)
        }
        if (insertArr.length > 0) {
          this.importData = insertArr
        } else {
          alert('正しく挿入できませんでした。')
        }
        this.csvFile = null
      }
      reader.readAsArrayBuffer(this.csvFile)
    },
  }
}
</script>

<style lang='scss' scoped>
.card-header {
  display: flex;
}
.desc {
  font-size: smaller;
  color: #666;
  text-align: left;
}
.table-td {
  vertical-align: middle;
  border: solid thin #ccc;
  input {
    min-height: 36px;
    background: transparent; border-radius: 0; height: 100%; width: 100%;
  }
  textarea { 
    min-height: 36px;
    resize: none;
    background: transparent; border-radius: 0; height: 100%; width: 100%;
  }
  .control {
    font-size: 12px;
    margin: 0 0.25rem;
  }
  .select::after {
    font-size: small;
    right: 1em;
  }
}
.table-th {
  text-align: center;
  vertical-align: middle;
  border: solid thin #ccc;
}
.footer-box {
  width: 100%;
  height: 64px;
  border-top: solid thin #ccc;
  display: flex;
  justify-content: space-around;
  align-items: center;
  flex-wrap: wrap;
  overflow: auto;
  button {
    width: 47%;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Calendar/organisms/ModalImportEvent.vue